import { useEffect, useState } from 'react';

const THD_STOREFRONT_COOKIE_KEY = 'THD_STOREFRONT';

/**
 * Simple cookie getter utility
 */
const getCookie = (name) => {
  if (typeof document === 'undefined') return null;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
};

/**
 * `useStorefront` hook to fetch data from the THD_STOREFRONT cookie
 */
export const useStorefront = (props = {}) => {
  const { skip = false } = props;

  const [storefront, setStorefront] = useState(null);

  const getStorefrontData = () => {
    try {
      const data = getCookie(THD_STOREFRONT_COOKIE_KEY);
      if (!data || data === 'undefined') {
        return null;
      }

      // Try to parse as JWT (if it has dots, it might be a JWT)
      if (data.includes('.')) {
        const payload = data.split('.')[1];
        if (payload) {
          try {
            const decodedPayload = atob(payload);
            return JSON.parse(decodedPayload);
          } catch (jwtError) {
            // If JWT parsing fails, try as regular JSON
            return JSON.parse(data);
          }
        }
      }

      // Try to parse as regular JSON
      return JSON.parse(data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error({
        message: `Error occurred while accessing cookie - ${THD_STOREFRONT_COOKIE_KEY}`,
        error
      });
      return null;
    }
  };

  useEffect(() => {
    if (!skip) {
      setStorefront(getStorefrontData());
    }
  }, [skip]);

  return storefront;
};